// 影视专题模拟数据（前端静态演示）
export const specials = [
  {
    id: "s-deep-space",
    title: "深海与星空：科幻影视的浪漫远征",
    subtitle: "当人类的想象力抵达未知的尽头",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20sci-fi%20landscape%20blending%20deep%20ocean%20trenches%20and%20starry%20space%2C%20glowing%20light%20rays%2C%20deep%20blue%20and%20gold%20palette%2C%20minimal%20epic%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=special-deep-space-cover&orientation=landscape",
    intro: "从万米海沟到银河边缘，科幻作品始终在替我们追问那些最难回答的问题。本专题精选近年最具代表性的科幻作品，带你一起潜入深海、飞向星空，在想象力的边界处，重新认识人类自己。",
    reasons: [
      "涵盖深海探索、太空航行、时间命题三种经典科幻母题",
      "视觉表达突出，适合大屏与投影环境下欣赏",
      "故事内核扎实，科幻外壳之下是动人的情感",
    ],
    items: ["m-deepsea-light", "t-star-route", "m-time-window", "m-dune-echo", "m-cloud-forest"],
    related: ["s-healing-life", "s-mystery-feast"],
  },
  {
    id: "s-mystery-feast",
    title: "悬疑推理盛宴：年度高能剧集精选",
    subtitle: "每一集都让你不敢快进",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20noir%20scene%20with%20fog%20and%20dim%20lamp%20light%20over%20scattered%20documents%2C%20slate%20blue%20and%20amber%20palette%2C%20minimal%20suspenseful%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=special-mystery-feast-cover&orientation=landscape",
    intro: "当真相被层层迷雾包裹，观众的心跳也随之加快。本专题汇聚口碑与讨论度双高的悬疑作品，从年代探案到都市犯罪，带你在抽丝剥茧的过程中，体验推理的极致快感。",
    reasons: [
      "剧情结构精巧，反转与伏笔设计扎实",
      "角色塑造立体，不只依赖情节驱动",
      "氛围营造出色，适合喜欢沉浸式追剧的观众",
    ],
    items: ["t-long-night", "t-mist-files", "t-cold-case-chase", "m-fog-city", "m-silent-confession"],
    related: ["s-deep-space", "s-costume-legend"],
  },
  {
    id: "s-healing-life",
    title: "治愈系生活图鉴：温暖光影合辑",
    subtitle: "慢下来，感受生活本来的样子",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20cozy%20evening%20scene%20with%20warm%20window%20light%20and%20plants%2C%20soft%20amber%20and%20cream%20palette%2C%20minimal%20warm%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=special-healing-life-cover&orientation=landscape",
    intro: "在快节奏的生活里，一些作品选择用温柔的方式说话。本专题收录治愈系影视作品，它们没有激烈的冲突，却能在某个安静的夜晚，让你重新感受到生活的暖意。",
    reasons: [
      "节奏舒缓，适合下班后放松观看",
      "聚焦日常情感，共鸣感强",
      "画面与配乐温暖治愈，观感舒适",
    ],
    items: ["t-tasty-life", "m-homebound-train", "m-city-glimmer", "t-spring-confession", "m-cloud-forest"],
    related: ["s-deep-space", "s-mystery-feast"],
  },
  {
    id: "s-costume-legend",
    title: "古装传奇：东方美学的影视解读",
    subtitle: "江湖与庙堂之间，自有诗意",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20abstract%20oriental%20ink%20wash%20mountains%20with%20mist%20and%20golden%20clouds%2C%20deep%20jade%20and%20gold%20palette%2C%20minimal%20elegant%20composition%2C%20no%20text%2C%20high%20detail%20illustration&width=800&height=500&seq=special-costume-legend-cover&orientation=landscape",
    intro: "青砖黛瓦，长剑如虹。古装题材承载着东方审美的独特韵味，也寄托着人们对侠义与传奇的想象。本专题精选兼具美学与故事的东方题材作品，带你走进那片诗意江湖。",
    reasons: [
      "服饰、置景、构图呈现浓厚的东方美学",
      "武侠与奇幻题材兼具，故事张力充足",
      "适合喜欢国风与传统文化题材的观众",
    ],
    items: ["m-mountain-sea", "t-young-hero", "t-long-night", "t-family-glory"],
    related: ["s-mystery-feast", "s-healing-life"],
  },
];